import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import { CampaignTypeFilter, CampaignTriggerType } from '@dev/ee-api/ee-api-models';
import { SimplePopover } from '@dev/ee-components';

import { GetCampaignsNames } from '@/store/campaigns/actions';
import { useGetAutomatedInfo } from '@/components/CampaignCreator/SettingsAndTracking/hooks/useGetAutomatedInfo';
import { ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { SendAfter } from './components/SendAfter';
import { FromOption } from './components/FromOption';
import { LinkOption } from './components/LinkOption';

const OptionWrapper = styled.div`
    max-width: 760px;
    margin-left: 60px;

    .popoverWrapper label {
        margin-top: 16px;
    }
`;

export const OptionsSection = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { triggerType } = useGetAutomatedInfo();
    const [eventTrigger, setEventTrigger] = useState<CampaignTriggerType>(triggerType);

    const eventOptions = [
        {
            label: t('onadd'),
            value: CampaignTriggerType.OnAdd,
        },
        {
            label: t('onopen'),
            value: CampaignTriggerType.OnOpen,
        },
        {
            label: t('onclick'),
            value: CampaignTriggerType.OnClick,
        },
    ];

    useEffect((): void => {
        dispatch(GetCampaignsNames([CampaignTypeFilter.Automated, CampaignTypeFilter.Draft]));
    }, []);

    const clickOnItemHandler = (e, obj): void => {
        setEventTrigger(obj.value as CampaignTriggerType);
        const modifyMap = new Map<string, any>();
        modifyMap.set('TriggerOptions.Type', obj.value as CampaignTriggerType);
        dispatch(ModifyCampaignMap(modifyMap));
    };

    return (
        <OptionWrapper>
            <SimplePopover
                id="autoresponder-dropdown"
                label={t('triggerevent')}
                listItemWidth={350}
                options={eventOptions}
                type="input"
                fullWidth
                defaultValue={CampaignTriggerType.OnAdd}
                value={eventTrigger}
                onItemClick={clickOnItemHandler}
            />
            {(eventTrigger === CampaignTriggerType.OnOpen || eventTrigger === CampaignTriggerType.OnClick) && (
                <FromOption />
            )}
            {eventTrigger === CampaignTriggerType.OnClick && <LinkOption />}
            <SendAfter />
        </OptionWrapper>
    );
};
